import React from "react";

import {Typography} from "@mui/material";
import {typografNode} from "../../utils/typograf";
import {SxProps} from "@mui/material/styles";
import {H6_FONT_WEIGHT, HEADING_LETTER_SPACING} from "./headingStyles";
import {getPartnerLanguage} from '../../locales/language';

type H6Props = {
    children: React.ReactNode;
    sx?: SxProps;
};

function H6({children, sx}: H6Props) {
    const isEnglish = getPartnerLanguage() === 'en';

    return (
        <Typography component="h6" variant="h6" sx={[{
            fontWeight: isEnglish ? H6_FONT_WEIGHT : 800,
            fontFamily: 'Nexa ExtraBold, Nexa Heavy, Nexa, Roboto, sans-serif',
            letterSpacing: isEnglish ? HEADING_LETTER_SPACING : 0,
            '@media screen and (min-width: 1400px)': {
                fontSize: '24px',
                lineHeight: 1.32,
            },
            '@media screen and (min-width: 1200px)': {
                fontSize: '24px',
                lineHeight: 1.32,
            },
            '@media screen and (min-width: 992px) and (max-width: 1199px)': {
                fontSize: '20px',
                lineHeight: 1.3,
            },
            '@media screen and (min-width: 768px) and (max-width: 1199px)': {
                fontSize: '20px',
                lineHeight: 1.32,
            },
            '@media screen and (max-width: 767px)': {
                fontSize: '16px',
                lineHeight: 1.32,
            },
            '@media screen and (max-width: 575px)': {
                fontFamily: 'Nexa ExtraBold, Nexa Heavy, Nexa, Roboto, sans-serif',
                fontWeight: 800,
                lineHeight: 1.32,
            },
        }, ...(Array.isArray(sx) ? sx : [sx ?? false])]}>
            {typografNode(children)}
        </Typography>
    );
}

export default H6
